module.exports = __webpack_public_path__ + "static/media/pin_green_light.e2373103.svg";